import React from 'react'
import PropTypes from 'prop-types'

import { FormControlLabel, FormGroup, Switch, TableCell, TableRow } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { cloneDeep, get } from 'lodash'

import SectionTable from './components/SectionTable'
import { LabeledCheckMark, LabeledX } from './components/Icons'
import SkeletonPair from './components/SkeletonPair'

const useStyles = makeStyles({
  rowHeight: {
    height: 60,
  },
})

const GeneralSection = ({ isEditing, applicationConfig, setApplicationConfig, loading, getStyle }) => {
  const classes = useStyles()
  const firstYearEnabled =
    applicationConfig && applicationConfig.firstYearConfiguration && applicationConfig.firstYearConfiguration.enabled
  const transferEnabled =
    applicationConfig && applicationConfig.transferConfiguration && applicationConfig.transferConfiguration.enabled

  const handleChange = (val, isFirstYear) => {
    const updatedState = cloneDeep(applicationConfig)
    const previousFirstYear = get(applicationConfig, 'firstYearConfiguration.enabled', false)
    const previousTransfer = get(applicationConfig, 'transferConfiguration.enabled', false)

    if (isFirstYear) {
      updatedState.firstYearConfiguration.enabled = val

      if (!previousTransfer && !val) {
        setApplicationConfig(updatedState, true)
        return
      }
      setApplicationConfig(updatedState)
    } else {
      updatedState.transferConfiguration.enabled = val

      if (!previousFirstYear && !val) {
        setApplicationConfig(updatedState, true)
        return
      }
      setApplicationConfig(updatedState)
    }
  }

  return (
    <SectionTable
      sectionName="Applicant Types"
      getStyle={getStyle}
    >
      <TableRow className={classes.rowHeight}>
        <TableCell
          style={{ color: getStyle() }}
          align="left"
          variant="body"
          component="th"
          size="small"
        >
          Supported Applicant Type(s)
        </TableCell>

        <TableCell
          align="left"
          size="small"
          data-testid="first-year-cell"
        >
          {loading ? (
            <SkeletonPair largerWidth={100} />
          ) : !isEditing ? (
            firstYearEnabled === true ? (
              <LabeledCheckMark
                label="Enabled"
                enabled={true}
                getStyle={getStyle}
              />
            ) : (
              <LabeledX
                label="Disabled"
                enabled={false}
                getStyle={getStyle}
              />
            )
          ) : (
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={firstYearEnabled}
                    onChange={(e) => handleChange(e.target.checked, true)}
                    color="primary"
                  />
                }
                label="Enabled"
              />
            </FormGroup>
          )}
        </TableCell>

        <TableCell
          align="left"
          size="small"
          data-testid="transfer-cell"
        >
          {loading ? (
            <SkeletonPair largerWidth={100} />
          ) : !isEditing ? (
            transferEnabled === true ? (
              <LabeledCheckMark
                label="Enabled"
                enabled={true}
                getStyle={getStyle}
              />
            ) : (
              <LabeledX
                label="Disabled"
                enabled={false}
                getStyle={getStyle}
              />
            )
          ) : (
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={transferEnabled}
                    onChange={(e) => handleChange(e.target.checked, false)}
                    color="primary"
                  />
                }
                label="Enabled"
              />
            </FormGroup>
          )}
        </TableCell>
      </TableRow>
    </SectionTable>
  )
}

GeneralSection.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  applicationConfig: PropTypes.object.isRequired,
  setApplicationConfig: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  getStyle: PropTypes.func.isRequired,
}

export default GeneralSection
